var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInceptron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.158706 90.190743",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.32039341,0,0,0.32039341,-193.03703,-175.63967)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "720.6,711.5 602.5,711.5 691.7,622.3 809.8,622.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "720.6,711.5 809.8,622.3 809.8,711.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "720.6,711.5 809.8,711.5 809.8,739.5 719.7,829.6 719.2,829.6 719.2,712.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "602.5,711.5 720.6,711.5 602.5,829.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 809.8,739.5 v 89.7 c -0.1,0.1 -0.3,0.3 -0.5,0.5 h -89.7 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "691.7,622.3 602.5,622.3 676.5,548.2 765.7,548.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "825.9,606.2 707.8,606.2 765.7,548.2 883.9,548.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "602.5,622.3 691.7,622.3 602.5,711.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "602.5,829.6 719.2,712.8 719.2,829.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 809.8,622.3 74,-74 c 0,0 0,130.6 0,206.9 -23.2,23.2 -49.3,49.3 -74,74 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInceptron);
export default __webpack_public_path__ + "static/media/inceptron.34ae9783348a5c0ad4e31d7344f432f6.svg";
export { ForwardRef as ReactComponent };